
// TODO: If we have another case like this, where we're
// fetching JSON like data from contentful, let's add
// a JSON input field to our ContentBlocks
export const extractContent = (htmlString?: string): string | undefined => {
  if (!htmlString) {
    return undefined;
  }

  return new DOMParser()
      .parseFromString(htmlString, "text/html")
      .documentElement.textContent || "";
};